import { createContext } from 'react';

interface CdProd {
  cd_prod_pai: string;
}
export const CdProdPaiContext = createContext<CdProd>({ cd_prod_pai: '' });
